// Mouvements Maison Fianchetto : apparitions au défilement, en-tête transparent sur l'accueil.
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Apparitions au défilement ----------
     Détection par position (getBoundingClientRect) : fiable même pour les images
     masquées par clip-path, que l'IntersectionObserver ignore. */
  let pending = [];
  const collect = (root = document) => {
    pending = pending.concat([...root.querySelectorAll('[data-mf-reveal]:not(.is-in)')]);
  };
  const reveal = (el) => {
    const waiting = [...el.querySelectorAll('img')].filter((img) => !(img.complete && img.naturalWidth));
    if (!waiting.length) return el.classList.add('is-in');
    let left = waiting.length;
    const done = () => {
      left -= 1;
      if (left <= 0) el.classList.add('is-in');
    };
    waiting.forEach((img) => {
      img.loading = 'eager';
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
    setTimeout(() => el.classList.add('is-in'), 2500); // filet de sécurité
  };
  const check = () => {
    if (reduce) {
      pending.forEach((el) => el.classList.add('is-in'));
      pending = [];
      return;
    }
    const limit = window.innerHeight * 0.92;
    const ahead = window.innerHeight * 1.4; // 19/10 : 1,4 écran d'avance au lieu de 2 (moins de photos chargées d'emblée sur téléphone)
    pending = pending.filter((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < ahead && !el.dataset.mfWarm) {
        // préchargement des images un peu avant qu'elles n'arrivent à l'écran
        el.dataset.mfWarm = '1';
        // sauf la 2e photo des cartes (survol / glissement) : elle reste différée tant qu'on ne la demande pas
        el.querySelectorAll('img[loading="lazy"]').forEach((img) => { if (!img.matches('.media--hover-effect > img + img')) img.loading = 'eager'; });
      }
      if (r.top < limit && r.bottom > 0) {
        reveal(el);
        return false;
      }
      return true;
    });
  };
  let raf = 0;
  const schedule = () => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      check();
    });
  };
  collect();
  check();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', (e) => {
    collect(e.target);
    schedule();
  });

  /* ---------- En-tête : transparent en haut de l'accueil, plein dès qu'on défile ---------- */
  const header = document.querySelector('.section-header');
  const setHeaderHeight = () => {
    if (header) document.documentElement.style.setProperty('--mf-header-h', `${header.offsetHeight}px`);
  };
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      document.body.classList.toggle('mf-scrolled', window.scrollY > 24);
      // l'emplacement de l'en-tête garde sa hauteur : la page ne bouge pas quand la barre apparaît
      if (header) {
        const bottom = header.offsetTop + header.offsetHeight;
        const compact = document.body.classList.contains('mf-compact');
        if (!compact && window.scrollY > bottom + 80) document.body.classList.add('mf-compact');
        else if (compact && window.scrollY < bottom) document.body.classList.remove('mf-compact');
      }
      ticking = false;
    });
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Carrousels de produits (flèches) ---------- */

    if (!customElements.get('mf-rail')) {
      customElements.define(
        'mf-rail',
        class extends HTMLElement {
          connectedCallback() {
            const list = this.querySelector('.mf-rail__list');
            const section = this.closest('section');
            section.querySelectorAll('.mf-rail__arrow').forEach((btn) =>
              btn.addEventListener('click', () => {
                const item = list.querySelector('.mf-rail__item');
                const step = item ? item.getBoundingClientRect().width + 24 : list.clientWidth * 0.8;
                list.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
              })
            );
            const update = () => {
              const [prev, next] = section.querySelectorAll('.mf-rail__arrow');
              prev.disabled = list.scrollLeft < 8;
              next.disabled = list.scrollLeft + list.clientWidth > list.scrollWidth - 8;
            };
            list.addEventListener('scroll', update, { passive: true });
            update();
          }
        }
      );
    }

  /* ---------- Mega menu : défilement des visuels de collection ---------- */
  if (!customElements.get('mf-mega-slides')) {
    customElements.define('mf-mega-slides', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.mf-mega__slide')];
        if (this.slides.length < 2) return;
        this.i = 0;
        const menu = this.closest('.mf-mega');
        const go = (n) => {
          this.i = (n + this.slides.length) % this.slides.length;
          this.slides.forEach((s, k) => s.classList.toggle('is-active', k === this.i));
        };
        const start = () => {
          if (reduce) return;
          clearInterval(this.t);
          this.t = setInterval(() => go(this.i + 1), 3200);
        };
        menu.querySelectorAll('[data-slide-target]').forEach((item) => {
          item.addEventListener('mouseenter', () => {
            const k = this.slides.findIndex((s) => s.dataset.slide === item.dataset.slideTarget);
            if (k > -1) {
              clearInterval(this.t);
              go(k);
            }
          });
          item.addEventListener('mouseleave', start);
        });
        start();
      }
      disconnectedCallback() {
        clearInterval(this.t);
      }
    });
  }

  /* ---------- Retour visuel au clic vers une autre page ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    const url = new URL(a.href, window.location.href);
    if (url.origin !== window.location.origin || (url.pathname === window.location.pathname && url.hash)) return;
    if (url.pathname.startsWith('/cart') && a.closest('cart-drawer, .cart-drawer')) return;
    document.documentElement.classList.add('mf-leaving');
  });
  // retour arrière depuis le cache : on retire l'état « en cours »
  window.addEventListener('pageshow', () => document.documentElement.classList.remove('mf-leaving'));

  /* ---------- Pied de page : menus repliables sur téléphone ---------- */
  const footerBlocks = document.querySelectorAll('.footer-block--menu');
  footerBlocks.forEach((block, i) => {
    const heading = block.querySelector('.footer-block__heading');
    const list = block.querySelector('.footer-block__details-content');
    if (!heading || !list) return;
    list.id = list.id || 'MfFooterList-' + i;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mf-footer-acc';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', list.id);
    btn.innerHTML = heading.innerHTML;
    heading.replaceChildren(btn);
    block.classList.add('mf-footer-collapsible');
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      block.classList.toggle('is-open', !open);
    });
  });
})();

/* Cartes produit : survoler une pastille de décor affiche la photo de ce décor
   (délégation d'événements : fonctionne aussi après un filtrage de la collection) */
(() => {
  // Écran tactile : pas d'aperçu au survol. Sur iPhone/iPad, un « survol » qui change la page absorbe le 1er tap,
  // et la pastille n'ouvrait la fiche qu'au 2e tap (28/10, enregistrement Clarity).
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const mainImg = (card) => card && card.querySelector('.card__media img');
  document.addEventListener('mouseover', (e) => {
    const sw = e.target.closest && e.target.closest('.mf-swatch[data-mf-img]');
    if (!sw) return;
    const card = sw.closest('.card-wrapper');
    const img = mainImg(card);
    if (!img) return;
    if (!img.dataset.mfSrc) {
      img.dataset.mfSrc = img.src;
      img.dataset.mfSrcset = img.getAttribute('srcset') || '';
      card.addEventListener('mouseleave', () => {
        img.src = img.dataset.mfSrc;
        if (img.dataset.mfSrcset) img.setAttribute('srcset', img.dataset.mfSrcset);
        card.querySelectorAll('.mf-swatch.is-active').forEach((s) => s.classList.remove('is-active'));
        card.classList.remove('mf-swatching');
      });
    }
    img.removeAttribute('srcset');
    img.src = sw.dataset.mfImg;
    card.querySelectorAll('.mf-swatch.is-active').forEach((s) => s.classList.remove('is-active'));
    sw.classList.add('is-active');
    card.classList.add('mf-swatching');
  });
})();

/* Menus du haut (Échiquiers, La Maison) : ouverture au survol sur ordinateur.
   Petit délai à la fermeture pour pouvoir glisser de l'intitulé vers le panneau. */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const menus = document.querySelectorAll('.header__inline-menu header-menu > details');
  menus.forEach((details) => {
    let timer;
    const summary = details.querySelector('summary');
    const open = () => {
      clearTimeout(timer);
      menus.forEach((d) => {
        if (d !== details && d.open) {
          d.open = false;
          d.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
      if (!details.open) {
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }
    };
    const close = () => {
      timer = setTimeout(() => {
        // fondu de sortie (18/10) avant de refermer réellement le menu
        details.classList.add('is-closing');
        timer = setTimeout(() => {
          details.classList.remove('is-closing');
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
        }, 260);
      }, 220);
    };
    details.addEventListener('mouseenter', () => details.classList.remove('is-closing'));
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
  });
})();
